(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mekkel-listen-watch"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mekkel-music-player')) {
  customElements.define('mekkel-music-player', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const track = this.querySelector('[data-video-track]');
      const previous = this.querySelector('[data-video-prev]');
      const next = this.querySelector('[data-video-next]');
      const motion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      const update = () => {
        if (!track) return;
        const maximum = track.scrollWidth - track.clientWidth;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maximum - 2;
      };
      if (track && previous && next) {
        previous.hidden = false;
        next.hidden = false;
        const move = (direction) => {
          const card = track.firstElementChild;
          if (!card) return;
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: motion() });
        };
        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('scroll', update, { passive: true });
        track.addEventListener('keydown', (event) => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }
        });
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(update);
          this.observer.observe(track);
        }
        update();
      }
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-play-video]');
        if (!link || !this.contains(link) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const id = link.dataset.videoId;
        if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return;
        event.preventDefault();
        const stage = this.querySelector('[data-video-stage]');
        const iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
        iframe.title = link.dataset.videoTitle;
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        stage.replaceChildren(iframe);
        this.querySelector('[data-current-title]').textContent = link.dataset.videoTitle;
        this.querySelector('[data-watch-link]').href = link.href;
        this.querySelectorAll('.mr-video-card').forEach((card) => {
          if (card.dataset.videoId === id) card.setAttribute('aria-current', 'true');
          else card.removeAttribute('aria-current');
        });
        stage.scrollIntoView({ behavior: motion(), block: 'nearest' });
      });
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
